import { Profile } from "./profile-model";
import { environment } from "src/environments/environment";
import { Stripe } from "./stripe-model";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import Swal from "sweetalert2";
import { UserService } from "../services/user/user.service";
import { NgxSpinnerService } from "ngx-spinner";
import { AuthService } from "../services/auth/auth.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AwsService } from "../services/aws/aws.service";

export class User {
  id!: number;
  username!: string;
  password!: string;
  email!: string;
  confirmed!: boolean;
  blocked!: boolean;
  token!: string;
  provider: string = "";
  isEmpty: boolean = true;
  is_deleted: boolean = true;
  customer_id?: string;
  profile: Profile = new Profile();
  stripe: Stripe = new Stripe({});
  createdAt?: string;
  is_connect_with?: boolean;
  switch_account?: string = "";

  constructor(data?: Partial<User>) {
    if (data) {
      Object.assign(this, data);
      if (data.id !== undefined) {
        this.isEmpty = false;
      }
      if (data.profile !== undefined) {
        this.profile = new Profile(data.profile);
      }
      if (data.stripe !== undefined) {
        this.stripe = new Stripe(data.stripe);
      }
    }
  }

  full_name() {
    return this.profile.full_name;
  }

  static toJson(user: any, jwt: string, is_connect_with: boolean,switch_account: string) {
    if (user.profile) {
      let userJson = {
        id: user.id,
        username: user.username,
        password: "",
        email: user.email,
        confirmed: user.confirmed,
        blocked: user.blocked,
        token: jwt,
        profile: user.profile,
        stripe: user.stripe,
        role: user.role.type,
        is_connect_with: is_connect_with,
        switch_account: switch_account,
        password_edit_by:user.password_edit_by,
        provider: user.provider
      };
      if (!user.profile.avatar) {
        userJson.profile.thumbnail = environment.default_avatar;
      } else {
        userJson.profile.thumbnail = AwsService.generate_link(
          user.profile.avatar.formats != undefined &&
            user.profile.avatar.formats != null
            ? user.profile.avatar.formats.thumbnail.url
            : user.profile.avatar.url
        );
      }
      return userJson;
    } else {
      return null;
    }
  }

  static attributeToJson(item: any) {
    let obj = item.attributes;
    obj["id"] = item.id;
    return obj;
  }

  static get_title() {
    return "Ajouter un nouveau utilisateur";
  }

  static get_inputs() {
    let formBuilder: FormBuilder = new FormBuilder();
    let form: FormGroup = formBuilder.group({
      password: ["", Validators.required],
      confirm_password: ["", Validators.required],
    });
    return [
      {
        name: "email",
        type: "text",
        label: "Adresse email",
        readOnly: true,
      },
      {
        name: "provider",
        type: "text",
        label: "Mode de connexion",
        readOnly: true,
      },
      {
        name: "blocked",
        type: "switch",
        label: "bloquer le compte",
        readOnly: false,
      },
      {
        name: "confirmed",
        type: "switch",
        label: "Confirmation d'email",
        readOnly: false,
      },
      {
        type: "section",
        label: "Réinitialiser le mot de passe",
        inputs: [
          { name: "password", placeholder: "Mot de passe", type: "password" },
          {
            name: "confirm_password",
            placeholder: "Confirmez le mot de passe",
            type: "password",
          },
        ],
        compare_inputs: true,
        readOnly: false,
        form: form,
        name_function: "change_password",
        onSubmit: () => {
          if (form.invalid) {
            Swal.fire("Erreur", "Veuillez saisir les champs vides", "error");
            return { success: false, values: {} };
          }
          const password = form.get("password")?.value;
          const confirmPassword = form.get("confirm_password")?.value;
          if (password != confirmPassword) {
            Swal.fire(
              "Erreur",
              "les mots de passe ne sont pas identiques",
              "error"
            );
            return { success: false, values: {} };
          }

          return {
            success: true,
            values: {
              password: password,
              passwordConfirmation: confirmPassword,
            },
          };
        },
      },
    ];
  }

  static get_form() {
    return {
      email: ["", Validators.required],
      provider: ["", Validators.required],
      blocked: [false, Validators.required],
      confirmed: [false, Validators.required],
    };
  }

  static get_relations() {
    return [];
  }
}
